import { EmptyStateBox } from '@elementary/common-ui/components';
import { Typography } from '@mui/material';

type Props = {
  message: string;
  onRetry: () => void;
};

const LoadErrorMessage = ({ message, onRetry }: Props) => (
  <Typography sx={{ color: 'common.gray11', fontSize: 'inherit' }}>
    {message}{' '}
    <EmptyStateBox.ClickableText
      onClick={() => onRetry()}
      sx={{ fontSize: 'inherit' }}
    >
      Try again
    </EmptyStateBox.ClickableText>
  </Typography>
);

export default LoadErrorMessage;
